export default "__VITE_ASSET__381099dd__"